<section>

  <div class="instruction-text">
    Map Charge Codes to Onelynk ChargeCodes
  </div>

  <div class="p-grid">
    <app-data-table [columns]="tableColumns" [value]="chargeCodeMappings" sortField="quickBooksUser">
      <ng-template #chargeCodeTemplate let-row="row" let-rowIndex="rowIndex" >
        <p-dropdown name="chargeCodeId-{{rowIndex}}" [placeholder]="Validation.DropdownPlaceholder"
                    [options]="chargeCodeDropDown"
                    [style]="{'overflow':'visible', 'max-width':'none'}"
                    [showClear]="true" [filter]="true"
                    [(ngModel)]="row.chargeCodeId"></p-dropdown>
      </ng-template>
    </app-data-table>
  </div>

  <div class="p-grid">
    <div class="p-col-12 p-md-12 p-lg-12" style="text-align:right;margin-top:10px;">
      <button pButton class="button-inaction" icon="fa fa-refresh" type="button" label="Import Charge Codes" (click)="importChargeCodeMappings()">
      </button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="onClickSaveMappings()">
      </button>
    </div>
  </div>

</section>
